"use client";

import React from "react";
import { useSearchParams } from "next/navigation";
import ObituaryListBanner from "../components/appcomponents/ObituaryListBanner";
import { findCityFromSlug, slugToCity } from "@/utils/citySlug";
import NextFunerals from "../components/appcomponents/NextFunerals";
import ObituaryListComponent from "../components/appcomponents/ObituaryListComponent";
import SponsorComponent from "../components/appcomponents/SponsorComponent";
import MemorialPageView from "../components/appcomponents/MemorialPageView";
import CommonFooter from "../components/appcomponents/CommonFooter";
import SpominskaStran from "../components/appcomponents/SpominskaStran";
import PartnersComponents from "../components/appcomponents/PartnerComponents";

const ObituaryListContent = ({
  cityParam,
  h1Text,
  regionSubtitle,
  initialObituaries,
  initialTotal,
}: {
  cityParam?: string;
  h1Text?: string;
  regionSubtitle?: string;
  initialObituaries?: any[];
  initialTotal?: number;
}) => {
  const urlSearchParams = useSearchParams();
  const region = urlSearchParams.get("region");
  const city = cityParam || urlSearchParams.get("city");
  const decodedCity = city
    ? (() => {
        try {
          return decodeURIComponent(city);
        } catch {
          return city;
        }
      })()
    : undefined;
  // Normalize slug-like city values (e.g. novo+mesto, nova+gorica) for subtitle display.
  const cityDisplay = decodedCity
    ? findCityFromSlug(decodedCity) || slugToCity(decodedCity)
    : undefined;
  // const displayH1 = h1Text || "Zadnje osmrtnice";
  // Changed because client asked exact H1 to be just "Osmrtnice" and city/region to be shown in separate <p>.
  const displayH1 = h1Text || "Osmrtnice";
  // City takes priority; fall back to server-resolved region subtitle from regionSeoOverrides.
  const subtitleDisplay = cityDisplay || regionSubtitle || undefined;

  return (
    <>
      <ObituaryListBanner
        image={"/cvetje.avif"}
        label={"Osmrtnice"}
        alt="osmrtnice ozadje"
        h1Text={displayH1}
        subtitleText={subtitleDisplay}
      />
      <ObituaryListComponent
        city={city || null}
        initialObituaries={(initialObituaries ?? []) as never[]}
        initialTotal={initialTotal}
      />
      <SponsorComponent
        text="Brez pomoči partnerjev ne bi šlo"
        region={region || null}
        city={city || null}
      />
      <NextFunerals />
      <SpominskaStran />
      <PartnersComponents />

      <CommonFooter currentPage="/osmrtnice" />
    </>
  );
};

export default ObituaryListContent;
